import { render, staticRenderFns } from "./customer-details.vue?vue&type=template&id=70d6801b&scoped=true"
import script from "./customer-details.vue?vue&type=script&lang=js"
export * from "./customer-details.vue?vue&type=script&lang=js"
import style0 from "./customer-details.vue?vue&type=style&index=0&id=70d6801b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d6801b",
  null
  
)

export default component.exports